import React, { Component } from 'react';
import { Icon, Select, Popup } from 'semantic-ui-react';
import _ from 'lodash';
import { connect } from 'react-redux';

import {
  TEMPERATURE_OPTIONS,
  TEMPERATURES,
  TEMPERATURES_MAP,
  CommonSectionPropTypes,
  TemperatureSectionGridFields,
} from 'Pages/manageproduction/helpers/Constants';
import { ProductionRecordDetailFieldEnum as ProdRecordDetailFields } from 'Common/FieldEnum';
import { createToast, toastType } from 'Common/ToastHelper';
import * as EditProductionSelectors from 'Pages/manageproduction/state/editproduction/selectors';
import * as EditProductionActions from 'Pages/manageproduction/state/editproduction/actions';

import { TemperatureRow } from './TemperatureRow';

class TemperatureSection extends Component {
  static propTypes = {
    ...CommonSectionPropTypes,
  };

  get numberOfColumns() {
    const { temperatures } = this.props;

    return temperatures.length + 1;
  }

  getRowStyle() {
    const numberOfColumns = this.numberOfColumns;
    const style = {};
    const gridColStyles = [];

    for (let i = 0; i < numberOfColumns - 1; i++) {
      gridColStyles.push('100px');
    }

    gridColStyles.push('200px');

    style.gridTemplateColumns = gridColStyles.join(' ');

    return style;
  }

  renderTemperatures = ({ details, isReadOnly, temperatures }) => {
    const { onInputChange } = this.props;
    const content = [];
    details.forEach((detail, i) => {
      content.push(
        <div
          className="grid-row"
          style={this.getRowStyle()}
          key={detail[ProdRecordDetailFields.ReactKey]}
        >
          <TemperatureRow
            {..._.pick(detail, TemperatureSectionGridFields)}
            isReadOnly={isReadOnly}
            temperatures={temperatures}
            onInputChange={onInputChange}
          />
        </div>
      );
    });

    return content;
  };

  addTemperature = () => {
    const { isReadOnly, addTemperature, temperatures } = this.props;

    if (isReadOnly) {
      return;
    }

    if (temperatures.length < TEMPERATURES.length) {
      addTemperature();
    }
  };

  renderRows = () => {
    const { temperatures, isReadOnly, detailsByRecipeCategory } = this.props;
    let itemsToRender = [];

    Object.keys(detailsByRecipeCategory).forEach((recipeCategoryId, i) => {
      let dividerRow = null;

      if (i !== 0) {
        dividerRow = <div className="divider-row" key={recipeCategoryId} />;
      }

      const items = this.renderTemperatures({
        details: detailsByRecipeCategory[recipeCategoryId],
        temperatures,
        isReadOnly,
      });

      if (items.length > 0) {
        if (dividerRow) {
          itemsToRender.push(dividerRow);
        }

        itemsToRender = itemsToRender.concat(items);
      }
    });

    return itemsToRender;
  };

  onTemperatureChange = i => (e, data) => {
    const { temperatures, changeTemperature } = this.props;
    const { value } = data;

    /** Allow a user to unselect a temperature, check user has selected a duplicate temperature */
    if (value && temperatures.indexOf(value) > -1) {
      createToast(
        toastType.error,
        'Error',
        'Temperature has already been selected.',
        true
      );
      return;
    }

    changeTemperature(i, value);
  };

  renderTemperatureDropdowns() {
    const { temperaturesInUse, isReadOnly, temperatures } = this.props;

    return (
      <div
        className="grid-row temperature-dropdowns"
        style={this.getRowStyle()}
      >
        {temperatures.map((temp, i) => {
          let disableDropdown = false;
          const temperature = TEMPERATURES_MAP[temp];

          if (temperature) {
            const fieldName = temperature.FieldName;
            disableDropdown = temperaturesInUse[fieldName];
          }

          return (
            <div className="grid-item" key={i}>
              <Popup
                content={temp}
                disabled={!Boolean(temp)}
                trigger={
                  <Select
                    className="menu-input ep-temp-dropdown"
                    fluid
                    options={TEMPERATURE_OPTIONS}
                    value={temp}
                    onChange={this.onTemperatureChange(i)}
                    disabled={disableDropdown || isReadOnly}
                  />
                }
              />
            </div>
          );
        })}
      </div>
    );
  }

  renderEmptyHeaders() {
    // First slot reserved for Temperature label, last reserved for Comments label
    const numberOfColumns = this.numberOfColumns - 2;

    if (numberOfColumns > 0) {
      return _.range(0, numberOfColumns).map(i => (
        <div className="grid-item" key={i} />
      ));
    }

    return null;
  }

  render() {
    const { temperatures } = this.props;

    return (
      <div className="ep-temperature-grid">
        <div className="grid-row grid-title-row">Temperatures</div>
        <div className="grid-header grid-row" style={this.getRowStyle()}>
          <div className="grid-item temp-header">
            Temperature:
            {temperatures.length < TEMPERATURES.length && (
              <Icon className="plus" link onClick={this.addTemperature} />
            )}
          </div>
          {this.renderEmptyHeaders()}
          <div className="grid-item">Comments</div>
        </div>
        {this.renderTemperatureDropdowns()}
        {this.renderRows()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  temperaturesInUse: EditProductionSelectors.getTemperaturesInUse(state),
  temperatures: EditProductionSelectors.getTemperatures(state),
});

const mapDispatchToProps = {
  addTemperature: EditProductionActions.addTemperature,
  changeTemperature: EditProductionActions.changeTemperature,
};

TemperatureSection = connect(
  mapStateToProps,
  mapDispatchToProps
)(TemperatureSection);

export { TemperatureSection };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/TemperatureSection.js